<style lang="scss" scoped>
.schedule-detail {
  @media only screen and (max-width: 767px) {
    overflow-x: auto;
  }
}
.schedule-item {
  display: flex;
  min-height: 23px;
  &.invalid {
    background-color: rgba(255, 110, 110, 0.45);
  }
}
.header-item,
.content-item {
  padding-left: 8px;
  padding-right: 8px;
  text-align: center;
  &.sol,
  &.ema,
  &.tst {
    padding-right: 24px;
  }
}
.header-item {
  font-size: 8px;
  border-radius: 2px 2px 0 0;
  &.in_bed {
    background: var(--border-color);
    width: 100%;
  }
}
.content-item {
  font-size: 9px;
  padding-top: 4px;
  padding-bottom: 4px;
  line-height: 1.7;
  &.in_bed {
    background: var(--border-color);
    width: 100%;
  }
}
.has-color {
  &.good {
    color: #40db4c;
  }
  &.medium {
    color: #ffbd26;
  }
  &.bad {
    color: #ff2d55;
  }
}

::v-deep .schedule-override-input {
  label,
  .label-error {
    margin-bottom: 8px;
  }
}
</style>

<template>
    <div v-if="schedule.length > 0" class="row">
        <div class="col-12 mb-44" v-for="(week, week_index) in schedule" :key="`week_${week_index}`">
            <div v-if="schedule[week_index - 1] && week_index !== 0" class="row mb-16">
                <div class="col-5 col-md-3">
                    <el-input v-model="schedule[week_index - 1].in_bed" @input="schedule[week_index - 1].changed = true" :scope="`week_${week_index}`" rule="required" type="time" step="1800" class="no-top-margin mb-0 schedule-override-input" :label="$t('pages.patients.time_to_bed')" :name="`to_bed_at_${week_index}`" :as="$t('pages.patients.time_to_bed')" :placeholder="$t('form-elements.to_bed_at_placeholder')"></el-input>
                </div>
                <div class="col-5 col-md-3">
                    <el-input v-model="schedule[week_index - 1].awaken" @input="schedule[week_index - 1].changed = true" :scope="`week_${week_index}`" rule="required" type="time" step="1800" class="no-top-margin mb-0 schedule-override-input" :label=" $t('pages.patients.time_out_bed')" :name="`out_bed_${week_index}`" :as="$t('pages.patients.time_out_bed')" :placeholder="$t('form-elements.in_sleep_at_placeholder')"></el-input>
                </div>
                <div class="col d-flex align-items-center pt-24">
                    <i-clock-rollback class="i-20 c-pointer opacity-75-hover" @click="() => recalculateSchedule(week_index)" />
                    <span v-if="recalculated === week_index" class="header-item bg-white-hover ml-8 px-16 py-4">Gegevens zijn herberekend. Gelieve de pagina te vernieuwen</span>
                </div>
                <div v-if="schedule[week_index - 1].changed" class="col-12 mt-16">
                    <button @click="submitSchedule(schedule[week_index - 1])" class="btn btn-primary btn-block btn-lg-inline d-block d-lg-flex" v-bind:class="{ disabled : loading.includes(week_index) }">
                        {{ $t('general.save') }}
                        <template v-if="loading.includes(week_index)">
                            <i-loader class="ml-2 i-20 my-auto"></i-loader>
                        </template>
                        <template v-if="success.includes(week_index)">
                            <i-check class="ml-2 i-20 my-auto"></i-check>
                        </template>
                    </button>
                </div>
            </div>

            <div class="bg-white-hover py-8 px-16 rounded-sm mb-24">
                <span class="text-primary-dark mr-24">{{ $t('pages.patients.week', { nr: week.week }) }}</span>
                <span class="text-primary-dark mr-24">Se: {{ week.sleep_efficiency }}% </span>
                <span v-if="week.week !== 1" class="text-primary-dark mr-24">{{ $t('pages.patients.from_to', { from: findweek(week.week -1).in_bed , to: findweek(week.week -1).awaken }) }}</span>
                <span v-if="week_index !== 0 && schedule[week_index - 1].overridden" class="small bg-gold text-white rounded px-8 py-4 text-uppercase fw-l">{{ $t('pages.patients.overridden') }}</span>
            </div>

            <div class="d-flex schedule-detail">
                <div class="col-auto d-flex flex-column px-0" v-for="(col, col_index) in ['day', 'in_bed', 'in_sleep', 'sol', 'awake', 'out_bed', 'ema', 'tib','waso', 'tst', 'se', 'nap_time', 'meds', 'wake_moment_1', 'wake_moment_2', 'wake_moment_3']" :key="col_index">

                    <!-- Header -->
                    <span v-if="!col.includes('wake_moment')" class="header-item schedule-item pt-4 pb-16" :class="[col]">{{ $t('pages.patients.' + col) }}</span>
                    <span v-else class="header-item schedule-item mr-8 px-0 pb-12" :class="[col]">
                        <span class="bg-white-hover px-16 py-4">{{ $t('pages.patients.' + col.slice(0, -2), { nr: col.charAt(col.length -1) }) }}</span>
                    </span>

                    <!-- Content -->
                    <div class="schedule-item" v-for="(day, day_index) in week.diary_entries" :key="`day_${day_index}`">
                        <span v-if="!col.includes('wake_moment')" class="content-item" :class="[col]">
                            <template v-if="col === 'day'">{{ day.date | moment('DD MMM') }}</template>
                            <span v-else-if="col === 'in_bed'" class="has-color" :class="sleepStatus(week.week, day, schedule[week_index - 1] && schedule[week_index - 1].awaken, schedule[week_index - 1] && schedule[week_index - 1].in_bed)">{{ (day.in_bed) ? $moment(day.in_bed).format('HH:mm') : '-' }}</span>
                            <template v-else-if="col === 'in_sleep'">{{ (day.asleep) ? $moment(day.asleep).format('HH:mm') : '-' }}</template>
                            <template v-else-if="col === 'sol'">{{ (day.asleep && day.in_bed) ? $moment.duration($moment(day.asleep, 'YYYY-MM-DD HH:mm').diff($moment(day.in_bed, 'YYYY-MM-DD HH:mm'))).asMinutes() + 'min' : '-' }}</template>
                            <template v-else-if="col === 'awake'">{{ (day.awaken) ? $moment(day.awaken).format('HH:mm') : '-' }}</template>
                            <span v-else-if="col === 'out_bed'" class="has-color" :class="wakeupStatus(week.week, day, schedule[week_index - 1] && schedule[week_index - 1].awaken)">{{ (day.out_bed) ? $moment(day.out_bed).format('HH:mm') : '-' }}</span>
                            <template v-else-if="col === 'ema'">{{ (day.out_bed && day.awaken) ? $moment.duration($moment(day.out_bed, 'YYYY-MM-DD HH:mm').diff($moment(day.awaken, 'YYYY-MM-DD HH:mm'))).asMinutes() + 'min' : '-' }}</template>
                            <span v-else-if="col === 'tib'" class="has-color" :class="inBedTimeStatus(week.week, day, schedule[week_index - 1] && schedule[week_index - 1].awaken, schedule[week_index - 1] && schedule[week_index - 1].in_bed)">{{ (day.sleep_time && day.awake_time) ?  $moment(day.sleep_time, 'HH:mm').add($moment.duration(day.awake_time).asMinutes(), 'minutes').format('HH:mm') : '-' }}</span>
                            <span v-else-if="col === 'waso'">{{ (day.awake_time) ?  day.awake_time : '-'}}</span>
                            <span v-else-if="col === 'tst'" class="has-color" :class="awakeTimeStatus(week.week, day, schedule[week_index - 1] && schedule[week_index - 1].awaken, schedule[week_index - 1] && schedule[week_index - 1].in_bed)">{{ (day.sleep_time) ? day.sleep_time: '-' }}</span>
                            <template v-else-if="col === 'se'">{{ (day.sleep_time && day.sleep_time && day.awake_time) ?  Math.round(($moment.duration($moment(day.sleep_time, 'HH:mm').diff($moment('00:00', 'HH:mm'))).asMinutes() / $moment.duration($moment($moment(day.sleep_time, 'HH:mm').add($moment.duration(day.awake_time).asMinutes(), 'minutes'), 'HH:mm').diff($moment('00:00', 'HH:mm'))).asMinutes()) * 100) + '%' : '-' }}</template>
                            <template v-else-if="col === 'nap_time'">
                                <el-naps-tooltip :naps="day.naps"></el-naps-tooltip>
                            </template>
                            <template v-else-if="col === 'meds'">
                                <el-medication-tooltip v-if="day.medication_entries.length > 0" :medication="day.medication_entries"></el-medication-tooltip>
                            </template>
                        </span>
                        <span v-else class="content-item pr-8 py-4" :class="[col]">
                            <template v-if="day.sleep_disturbances[col.charAt(col.length -1) -1]">
                                <span class="px-4">{{ day.sleep_disturbances[col.charAt(col.length -1) -1].start_time }}</span>
                                <span class="px-4">{{ day.sleep_disturbances[col.charAt(col.length -1) -1].end_time }}</span>
                                <span class="px-4"> {{ calcSleepDisturbance(day, col) }}m</span>
                            </template>
                        </span>
                    </div>
                </div>
                <div class="col-auto d-flex flex-column px-0">
                    <span class="header-item schedule-item pt-4 pb-16" :class="['wakeup_extra']">&nbsp;</span>
                    <div class="schedule-item" v-for="(day, day_index) in week.diary_entries.filter(d => d.id !== null)" :key="`day_${day_index}`">
                        <span v-if="day.sleep_disturbances.length > 4" class="content-item pr-8 py-4 bg-white-hover rounded" :class="['wakeup_extra']">
                            +{{ day.sleep_disturbances.length - 3}}
                        </span>
                    </div>
                </div>
            </div>

        </div>
    </div>
    <div v-else class="mb-16 text-dark text-center">
        {{ $t('pages.patients.user_has_no_generated_schedule_yet') }}
    </div>
</template>

<script>
import { ElInput, ElMedicationTooltip, ElNapsTooltip } from '@/components/forms'

// Extends
import hasForm from '@/components/forms/has-form';

export default {
    name: 'admin-patient-schedule',

    mixins: [hasForm],

    components: { ElInput, ElMedicationTooltip, ElNapsTooltip },

    props: {
        patient: {
            required: true
        },
        schedule: {
            default: false
        }
    },

    data: () => ({
        recalculated: null,
        serverDateFormat: "YYYY-MM-DD HH:mm:ss",
        loading: [],
        success: [],
    }),

    methods: {
        isValid(col, day) {
            if (col === 'awake' && day === '00:00') return false
            if (col === 'out_bed' && day === '00:00') return false
            if (col === 'ema' && day === '0u 00m') return false

            return true
        },
        findweek(weekNr) {
            let week = this.schedule.find(w => (w && w.week === weekNr))

            if (week) return week

            return {}
        },
        submitSchedule(week) {
            this.$validator.validateAll(`week_${week.week}`).then(res => {
                if (res) {
                    let data = {
                        week_id: week.week,
                        awaken: week.awaken,
                        in_bed: week.in_bed,
                        overridden: true
                    }
                    this.loading.push(week.week)
                    this.$store.dispatch('schedule/updateSchedule', { user_id: this.patient.id, data: data }).then(
                        () => {
                            this.loading = this.loading.filter(l => l !== week.week)
                            this.success.push(week.week)
                            week.overridden = true
                            week.changed = false
                        },
                        error => {
                            this.loading = this.loading.filter(l => l !== week.week)
                            this.success = this.success.filter(l => l !== week.week)
                            this.server_error = error
                        }
                    )
                }
            })
        },

        calcSleepDisturbance(day, col) {
            let dist = this.$moment.duration(this.$moment(day.sleep_disturbances[col.charAt(col.length - 1) - 1].end_time, 'HH:mm').diff(this.$moment(day.sleep_disturbances[col.charAt(col.length - 1) - 1].start_time, 'HH:mm'))).asMinutes()

            if (dist < 0)
                dist = this.$moment.duration(this.$moment(day.sleep_disturbances[col.charAt(col.length - 1) - 1].end_time, 'HH:mm').diff(this.$moment(day.sleep_disturbances[col.charAt(col.length - 1) - 1].start_time, 'HH:mm').add(-1, 'd'))).asMinutes()

            return dist
        },
        recalculateSchedule(week) {
            this.$store.dispatch('schedule/recalculateSchedule', { user_id: this.$route.params.id, week: week }).then(() => {
                this.recalculated = week
            })
        },
        sleepStatus(week, entry, rec_wakup, rec_tobed) {
            if (week === 1) return 'no-color'
            if (!rec_wakup || !rec_tobed || !entry.asleep) return 'medium'

            let date_inBed = this.$moment(entry.in_bed, this.serverDateFormat)
            let date_outBed = this.$moment(entry.out_bed, this.serverDateFormat)
            let date_asleep = this.$moment(entry.asleep, this.serverDateFormat)
            let date_awake = this.$moment(entry.awake, this.serverDateFormat)
            let rec_in_bed = this.$moment(entry.date + ' ' + rec_tobed, this.serverDateFormat)

            if (rec_in_bed.hour() > 17 && date_inBed.hour() <= 17)
                date_inBed.add(1, 'days')

            if (rec_in_bed.hour() <= 17 && date_inBed.hour() > 17)
                date_inBed.add(-1, 'days')

            if (date_inBed.isAfter(date_outBed))
                date_outBed.add(1, 'days')

            if (date_inBed.isAfter(date_asleep) || date_inBed.isSame(date_asleep))
                date_asleep.add(1, 'days')

            if (date_inBed.isAfter(date_awake))
                date_awake.add(1, 'days')

            if (date_inBed.isSame(rec_in_bed)) return 'good'

            if (date_inBed.isAfter(rec_in_bed)) return 'medium'

            return 'bad'
        },
        wakeupStatus(week, entry, rec_wakup) {
            if (week === 1) return 'no-color'
            if (!rec_wakup) return 'medium'

            let awakenMoment = this.$moment(entry.out_bed, this.serverDateFormat)
            let recAwakenBedMoment = this.$moment(entry.date + ' ' + rec_wakup + ":00", this.serverDateFormat)

            if (!awakenMoment.isSame(recAwakenBedMoment, 'd'))
                recAwakenBedMoment.add(1, 'd')

            if (awakenMoment.isSame(recAwakenBedMoment)) return 'good'
            if (awakenMoment.isBefore(recAwakenBedMoment)) return 'medium'

            let timeDiff = this.$moment.duration(awakenMoment.diff(recAwakenBedMoment)).asMinutes()

            if (timeDiff === 0) return 'good'

            else return 'bad'
        },
        inBedTimeStatus(week, entry, rec_wakup, rec_tobed) {
            if (week === 1) return 'no-color'
            if (!rec_wakup || !rec_tobed) return 'medium'

            let date_inBed = this.$moment(entry.in_bed, this.serverDateFormat)
            let date_outBed = this.$moment(entry.out_bed, this.serverDateFormat)
            let date_asleep = this.$moment(entry.asleep, this.serverDateFormat)
            let date_awake = this.$moment(entry.awake, this.serverDateFormat)
            let rec_in_bed = this.$moment(entry.date + ' ' + rec_tobed, this.serverDateFormat)

            if (rec_in_bed.hour() > 17 && date_inBed.hour() <= 17)
                date_inBed.add(1, 'days')

            if (rec_in_bed.hour() <= 17 && date_inBed.hour() > 17)
                date_inBed.add(-1, 'days')

            if (date_inBed.isAfter(date_outBed))
                date_outBed.add(1, 'days')

            if (date_inBed.isAfter(date_asleep) || date_inBed.isSame(date_asleep))
                date_asleep.add(1, 'days')

            if (date_inBed.isAfter(date_awake))
                date_awake.add(1, 'days')

            if (date_inBed.isAfter(rec_in_bed) || date_inBed.isSame(rec_in_bed)) return 'good'

            return 'bad'
        },
        awakeTimeStatus(week, entry, rec_wakup, rec_tobed) {
            if (week === 1) return 'no-color'
            if (!rec_tobed || !rec_tobed) return 'medium'

            let tst = this.$moment.duration(entry.sleep_time).asMinutes()
            let rec_tst = this.$moment.duration(this.$moment(rec_wakup, 'HH:mm').diff(this.$moment(rec_tobed, 'HH:mm'))).asMinutes()
            if (rec_tst < 0)
                rec_tst = this.$moment.duration(this.$moment(rec_tobed, 'HH:mm').diff(this.$moment(rec_wakup, 'HH:mm'))).asMinutes()

            if (tst <= rec_tst) return 'good'

            if ((tst > rec_tst) && (tst <= rec_tst + 15)) return 'medium'

            return 'bad'
        }
    }

}
</script>
